export type GameId = 1001 | 1002 | 1003 | 1004 | 1005 | 1006 | 1007 | 1008 | 1009 | 1010 | 1011 | 1012 | 1013 | 1014 | 1015 | 1016 | 1017 | 1018 | 11111 | 2001 | 2002 | 2003 | 2004 | 3001 | 3002 | 3003 | 3004 | 3005 | 3006 | 3007 | 3008 | 3009 | 3010 | 3011 | 3012 | 3013 | 3014 | 3015;

export interface ConfiguredGameRuntime {
  gameId: GameId;
  packageId: number;
}

export const GAME_PACKAGE_ID_MAP: Record<GameId, number> = {
  1001: 1,
  1002: 2,
  1003: 3,
  1004: 4,
  1005: 5,
  1006: 6,
  1007: 7,
  1008: 8,
  1009: 9,
  1010: 10,
  1011: 11,
  1012: 12,
  1013: 13,
  1014: 17,
  1015: 1,
  1016: 1,
  1017: 19,
  1018: 20,
  11111: 1,
  2001: 15,
  2002: 14,
  2003: 16,
  2004: 18,
  3001: 21,
  3002: 22,
  3003: 23,
  3004: 25,
  3005: 26,
  3006: 27,
  3007: 29,
  3008: 30,
  3009: 31,
  3010: 32,
  3011: 33,
  3012: 34,
  3013: 35,
  3014: 36,
  3015: 1
};

export function getConfiguredGameRuntime(gameId: GameId): ConfiguredGameRuntime {
  return {
    gameId,
    packageId: GAME_PACKAGE_ID_MAP[gameId]
  };
}
